const { h, render, Component } = require('preact');

class IssueFormView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
          <div className="issue-email-form">
            <label> <span className="issue">{I18n.translate('js.modules.support.issue')}</span>
              <span className="reason-text">{this.props.reason_text}</span>
            </label>
          </div>
        )
    }
}

module.exports = IssueFormView